import { Fragment } from 'react';

import useTeamEntryManagementContextView from './UseTeamEntryManagementContextView';

import Headings from '@usas/ui-web/components/headings/Headings';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const TeamEntryManagementContextView = ({ children }) => {
  const {
    meetCompetitionSummaryState,
    searchMeetState,
    onHomeClicked
  }
    = useTeamEntryManagementContextView();
  return (
    <Fragment>
      <div className={searchMeetState.showMeetHeader === true ? global.DisplayComponent : global.HideComponent}>
        <div className="row">
          <div className="col-xs-12">
            <button className={global.HeaderButton} onClick={onHomeClicked}>
              <Headings.H3
                className={[global.NoBottomMargin, 'col-xs-12'].join(' ')}
                excludeBar={true}>
                Team Entry Management
              </Headings.H3>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <hr className="usas-bar-turmeric" />
          </div>
        </div>
        <div className={"row"}>
          <div className="col-xs-12 col-sm-12">
            <p className={global.HeaderText}><b>Meet Name:</b> {meetCompetitionSummaryState?.objData?.meetName || ''} </p>
            <p className={global.HeaderText}><b>Meet Dates:</b> {meetCompetitionSummaryState?.isObjLoaded ? `${meetCompetitionSummaryState?.objData?.startDate ? formatDate(meetCompetitionSummaryState.objData.startDate) : ''} - ${meetCompetitionSummaryState.objData.endDate ? formatDate(meetCompetitionSummaryState.objData.endDate) : ''}` : ''}</p>
            {meetCompetitionSummaryState?.objData?.meetPacketUrl && <p className={global.HeaderText}><b>Meet Packet:</b> <a href={meetCompetitionSummaryState?.objData?.meetPacketUrl} target="_blank" rel="noreferrer">Click Here to View</a></p>}
          </div>
        </div>
      </div>
      {children}
    </Fragment>
  );
};

export default TeamEntryManagementContextView;